<div *ngIf="show" class="overlay" style="background-color: rgba(0, 0, 0, 0.12);">
    <div class="d-flex justify-content-center" style="flex-direction: column;align-items: center; height: 100vh;">
        <em class="pi-spin pi pi-spinner" style="font-size: 75px;"></em>
    </div>
</div>